export const LOCK_RENEWAL_BUFFER_MS = 5 * 1000;
export const LOCK_RETRY_DELAY_MS = 5 * 1000;

export function getIsLockedByOtherUser({
  isCalendarLocked,
  lockAcquired,
  sessionUserId,
  lockedByUserId,
}: {
  isCalendarLocked: boolean;
  lockAcquired?: boolean;
  sessionUserId?: string | null;
  lockedByUserId?: string | null;
}): boolean {
  if (!isCalendarLocked) {
    return false;
  }

  if (sessionUserId && lockedByUserId) {
    return sessionUserId !== lockedByUserId;
  }

  if (lockAcquired) {
    return false;
  }

  return true;
}

export function getLockRenewalDelayMs(
  lockedUntil?: string | null,
  nowMs: number = Date.now()
): number {
  const lockedUntilMs = lockedUntil
    ? new Date(lockedUntil).getTime()
    : Number.NaN;

  if (Number.isNaN(lockedUntilMs)) {
    return LOCK_RETRY_DELAY_MS;
  }

  const renewalDelayMs = lockedUntilMs - nowMs - LOCK_RENEWAL_BUFFER_MS;
  return renewalDelayMs > 0 ? renewalDelayMs : LOCK_RETRY_DELAY_MS;
}
